module.exports = __webpack_public_path__ + "static/media/DinningArea-b-c-f.eba61ee6.webp";